import Collection from '../collection';
import TypeGroup from '../model/type.group';

export default Collection.extend( {
	endpoint: 'types/groups/list?apiVersion=2.0',
	responseAt: 'items',
    model: TypeGroup
} );


// WEBPACK FOOTER //
// ./src/js/collection/type.groups.js